// C4a — deep-link from the Analytics «провалы по категориям» strip to the Feed,
// pre-filtered to one R-failure category.
//
// Mirrors the Feed's EXISTING addressable contract: FeedScreen reads
// ``?failure_category=<key>`` via ``useSearchParams`` (FeedScreen.tsx:187),
// reflects it as a clearable chip and forwards it to the jobs query
// (FeedScreen.tsx:293 → useJobs → indexed membership on Job.failure_category).
// No backend change; no new query parameter.
//
// The key is the MACHINE ``FailureCategoryR`` value, never a localized label —
// so a future label edit can never break the deep-link. ``URLSearchParams``
// gives correct, stable encoding (the R keys are ``[a-z_]`` today, but this
// stays robust if that ever changes).

import type { FailureCategoryR } from '../../api/types';

export function failureCategoryFeedUrl(category: FailureCategoryR): string {
  return `/?${new URLSearchParams({ failure_category: category }).toString()}`;
}
